import { render } from "./WinDrawLose.vue?vue&type=template&id=5489e20a"
import script from "./WinDrawLose.vue?vue&type=script&lang=js"
export * from "./WinDrawLose.vue?vue&type=script&lang=js"

import "./WinDrawLose.vue?vue&type=style&index=0&id=5489e20a&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__